import Vue from 'vue'
import VueMeta from 'vue-meta'
import VeeValidate, { Validator } from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import VueTheMask from 'vue-the-mask'
import App from './App'
import router from './router'
import AppServices from './services'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min.js'
import './components'

// inspinia js resources
import VueFroala from 'vue-froala-wysiwyg'
import 'froala-editor/js/froala_editor.pkgd.min'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'froala-editor/js/languages/pt_br.js'

// dashboard dependencies
import {TabsPlugin, TablePlugin, ModalPlugin, ButtonPlugin} from 'bootstrap-vue'

// import * as Bootstrap from 'bootstrap-vue'

import vueNumeralFilterInstaller from 'vue-numeral-filter'
import VueApexCharts from 'vue-apexcharts'

import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(VueMeta)

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
})

Vue.use(VueTheMask)

Vue.use(VueFroala)

Vue.use(TabsPlugin)

Vue.use(TablePlugin)

Vue.use(ModalPlugin)

Vue.use(ButtonPlugin)

Vue.use(vueNumeralFilterInstaller, { locale: 'pt-br' })

Vue.component('apexchart', VueApexCharts)

Validator.localize('pt_BR', ptBR)

Object.keys(AppServices).forEach(k => Vue.use(AppServices[k]))

Vue.component('datetime', Datetime)

Settings.defaultLocale = 'pt-br'

Vue.config.productionTip = false

/* eslint-disable-next-line no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js